import React from 'react';
import { motion } from 'framer-motion';
import { FlashlightIcon } from 'lucide-react';
export function FamilyBanner() {
  return <section className="relative bg-[#0a0a0a] py-12 sm:py-20 overflow-hidden" data-id="element-121">
      <div className="absolute inset-0 bg-noise opacity-10 mix-blend-overlay pointer-events-none" data-id="element-122" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] max-w-[120vw] bg-[#8b1a1a]/10 rounded-full blur-[150px] pointer-events-none" data-id="element-123" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative rounded-lg overflow-hidden border border-[#8b1a1a]/30 shadow-[0_30px_80px_rgba(0,0,0,0.7)]" data-id="element-125">
          {/* 5:4 banner */}
          <div className="relative aspect-[5/4]" data-id="element-126">
            <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1600&auto=format&fit=crop" alt="A family gathered around the dinner table examining case files and clues together" className="w-full h-full object-cover filter grayscale contrast-110 brightness-90" data-id="element-127" />
            {/* Noir tints + vignette */}
            <div className="absolute inset-0 bg-[#8b1a1a]/15 mix-blend-multiply" data-id="element-128" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/30 to-[#0a0a0a]/40" data-id="element-129" />
            <div className="absolute inset-0 bg-noise mix-blend-overlay opacity-25 pointer-events-none" data-id="element-130" />

            {/* Caption block */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 sm:p-12" data-id="element-131">
              <div className="inline-flex items-center self-start space-x-2 text-[#ece3d0] mb-3 sm:mb-4 bg-[#8b1a1a]/30 px-3 py-1.5 rounded-full border border-[#8b1a1a]/40 backdrop-blur-sm" data-id="element-132">
                <FlashlightIcon className="w-4 h-4" data-id="element-133" />
                <span className="font-typewriter text-xs sm:text-sm tracking-wider uppercase" data-id="element-134">
                  Tonight's Investigation
                </span>
              </div>
              <h2 className="font-typewriter text-2xl sm:text-4xl lg:text-5xl text-[#ece3d0] drop-shadow-lg max-w-2xl leading-tight" data-id="element-135">
                The whole table becomes the
                <span className="text-[#8b1a1a]" data-id="element-136"> investigation room.</span>
              </h2>
              <p className="font-serif-body text-[#ece3d0]/80 text-base sm:text-xl italic mt-3 sm:mt-4 max-w-xl" data-id="element-137">
                Dinner gets cold. The clues don't. Gather everyone, lay out the
                evidence, and crack the case together.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}